// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1wg27","tab":"styles_tab__3gkrN"};